










import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'

export default
  components: {
    Popup
    BlueButton
  }

  props:
    title:
      type: String
      default: '削除してよろしいですか？'

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    send: () ->
      @$emit('send')
  }
